import request from '@/utils/request'

/**
 * 获取积分规则列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listIntegralShopRule(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integralShopRule.listIntegralShopRule',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加积分规则
 * @param {Object} data 积分规则数据
 * @returns {Promise} Promise对象
 */
export function saveIntegralShopRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integralShopRule.saveIntegralShopRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新积分规则
 * @param {Object} data 积分规则数据
 * @returns {Promise} Promise对象
 */
export function updateIntegralShopRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integralShopRule.updateIntegralShopRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除积分规则
 * @param {Object} data 积分规则数据
 * @returns {Promise} Promise对象
 */
export function deleteIntegralShopRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integralShopRule.deleteIntegralShopRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}